import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions } from "@tanstack/react-query";

import { usePaginateQuery } from "@/hooks/usePaginateQuery";
import { api } from "@/lib/api";
import { type Paginate, type SearchRequest } from "@/types/models";

import { type Tag } from "../types";

export type TagList = Paginate<Tag>;

export const tags = createQueryKeys("performance-objectives-tags", {
  all: (page?: number, filter?: SearchRequest) => [{ page, filter }],
  one: (id?: number) => [id],
});

const include = "";

export const fetchTagListQueryOptions = (
  page: number = 0,
  search?: SearchRequest,
) =>
  queryOptions({
    ...tags.all(page, search),
    queryFn: () =>
      api
        .get<TagList>(`/performance/objectives/tags`, {
          params: { page, include, ...search },
        })
        .then((response) => response.data),
  });

export const useFetchTagList = (search?: SearchRequest) =>
  usePaginateQuery((page) => fetchTagListQueryOptions(page, search));
